import { http } from "./http";
import type { SessionDto } from "./authApi";

/** Admin management of managers (whitelabel brands) and their portal logins. */

export interface ManagerAdmin {
  managerId: number;
  name: string;
  portalUrl: string;
  portalName: string;
  mailFrom: string;
  mailFromName: string;
  footerHtml: string;
  hasLogo: boolean;
  logoMimeType: string;
  /** ManagerSetting brand.primaryColor; null when not configured. */
  primaryColor: string | null;
  customerCount: number;
  loginCount: number;
}

export interface ManagerDetailsBody {
  name: string;
  portalUrl: string;
  portalName: string;
  mailFrom: string;
  mailFromName: string;
  footerHtml: string;
}

export interface ManagerLogin {
  loginId: number;
  username: string;
}

const base = "/api/admin/managers";

export const managersAdminApi = {
  list: () => http<ManagerAdmin[]>(base),
  get: (managerId: number) => http<ManagerAdmin>(`${base}/${managerId}`),
  create: (name: string) => http<{ managerId: number }>(base, { method: "POST", body: JSON.stringify({ name }) }),
  update: (managerId: number, body: ManagerDetailsBody) =>
    http<ManagerAdmin>(`${base}/${managerId}`, { method: "PUT", body: JSON.stringify(body) }),

  logins: (managerId: number) => http<ManagerLogin[]>(`${base}/${managerId}/logins`),
  upsertLogin: (managerId: number, body: { loginId: number; username: string; password: string }) =>
    http<ManagerLogin[]>(`${base}/${managerId}/logins`, { method: "PUT", body: JSON.stringify(body) }),
  /** Impersonate: sign in as this manager login (admin only); the session becomes Kind "Manager" with originalKind "Admin". */
  switchToLogin: (managerId: number, loginId: number) =>
    http<SessionDto>(`${base}/${managerId}/logins/${loginId}/switch`, { method: "POST" }),
  deleteLogin: (managerId: number, loginId: number) =>
    http<ManagerLogin[]>(`${base}/${managerId}/logins/${loginId}`, { method: "DELETE" }),
};
